import type { SupervisorInfoInput } from '@@partner:graphql/mutation/employees/saveSupervisor.gql'
import type { Supervisor } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

export interface SupervisorFormState {
  id?: GQL_ID
  firstName: string
  lastName: string
  phone: string
  status: number
  email: string

  changePassword: boolean
  password: string
  repeatPassword: string
  shopIds?: GQL_ID[]
  shops?: {
    id?: GQL_ID
    name?: string
  }
}

export const PROMOCODE_DEFAULT_STATE: SupervisorFormState = {
  id: undefined,
  firstName: '',
  lastName: '',
  phone: '',
  status: 0,
  email: '',
  changePassword: false,
  password: '',
  repeatPassword: '',
  shopIds: [],
  shops: {
    id: undefined,
    name: ''
  }
}

export const makeSupervisorFormState = (
  supervisor?: Supervisor
): SupervisorFormState => {
  return mapApiDataToState(supervisor ?? ({} as Supervisor))
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (
  state: SupervisorFormState
): SupervisorInfoInput => ({
  id: state.id,
  first_name: state.firstName,
  last_name: state.lastName,
  phone: state.phone,
  email: state.email,
  status: Number(state.status) ?? 0,
  password: state.changePassword || !state.id ? state.password : undefined,
  shopIds: state.shopIds
})

export const mapApiDataToState = (data: Supervisor): SupervisorFormState => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phone: data.phone,
  status: data.status,
  email: data.email,
  password: '',
  repeatPassword: '',
  changePassword: false,
  shopIds: data.shops?.map((item) => Number(item.id))
})
